// Happy or Sad Metadata.
import HappySadSVG from '../../../assets/images/Thoughts/HappySad.svg';

const HappySadMetadata = {
  id: 'HappySad',
  title: 'Happy or Sad?',
  description: 'Individualism and the Collective',
  thumbnail: HappySadSVG,
  featured: false,
};

export default HappySadMetadata;
